"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .ant-collapse-item > .ant-collapse-header {\n    padding-left: 34px;\n  }\n  .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n    left: 0px;\n    font-size: 24px;\n    color: ", ";\n    transition: transform 0.25s linear;\n    transform: rotate(0deg);\n    padding: 0;\n    top: 10px;\n  }\n  .ant-collapse-item.ant-collapse-item-active > .ant-collapse-header .ant-collapse-arrow {\n    transform: rotate(90deg);\n  }\n  .ant-collapse-content {\n    padding-left: 34px;\n    > .ant-collapse-content-box {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapseRoot = void 0;

var web_1 = require("@thesisedu/web");

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var icons_1 = require("../../icons");

function CollapseRoot(props) {
  return react_1.default.createElement(CollapseWrapper, null, react_1.default.createElement(antd_1.Collapse, Object.assign({
    expandIcon: function expandIcon() {
      return react_1.default.createElement(web_1.AntIconWrapper, {
        className: 'ant-collapse-arrow',
        children: react_1.default.createElement(icons_1.NavArrowRight, null)
      });
    }
  }, props)));
}

exports.CollapseRoot = CollapseRoot;
var CollapseWrapper = web_1.styled.div(_templateObject(), function (props) {
  return props.theme['@text-color-secondary'];
});